import React, { memo } from 'react';
import { CalendarGrid } from '../components/CalendarGrid';
import { ScheduleItem } from '../types/scheduleItem.types';
import { TimeScale } from '../types/calendar.types';

interface WeekViewProps {
  currentDate: Date;
  items: ScheduleItem[];
  timeScale: TimeScale;
  onItemClick?: (item: ScheduleItem) => void;
  onItemDragStart?: (e: React.DragEvent, item: ScheduleItem) => void;
  onItemDragEnd?: () => void;
  onDrop?: (e: React.DragEvent, date: Date, time: Date) => void;
  onCreateClick?: (date: Date, time: Date) => void;
  allowDrag?: boolean;
  onOpenWorkOrder?: (invoiceDocId: number) => void;
}

export const WeekView: React.FC<WeekViewProps> = memo(({
  currentDate,
  items,
  timeScale,
  onItemClick,
  onItemDragStart,
  onItemDragEnd,
  onDrop,
  onCreateClick,
  allowDrag = true,
  onOpenWorkOrder,
}) => {
  return (
    <CalendarGrid
      viewType="week"
      currentDate={currentDate}
      items={items}
      timeScale={timeScale}
      onItemClick={onItemClick}
      onItemDragStart={onItemDragStart}
      onItemDragEnd={onItemDragEnd}
      onDrop={onDrop}
      onCreateClick={onCreateClick}
      allowDrag={allowDrag}
      onOpenWorkOrder={onOpenWorkOrder}
    />
  );
});

WeekView.displayName = 'WeekView';
